// src/features/display/useDisplaySpeech.js
import { useCallback } from 'react';
import { ttsFactory } from '../../services/tts/TtsFactory';
import { replacePlaceholders } from '../../utils/ttsUtils';

export const useDisplaySpeech = ({
  settings,
  locale,
  isMutedByPrimary,
  showNotification,
  t,
  appConfig,
  handleSettingChange
}) => {
  const speak = useCallback(async (text, levelData = null, columns = null, force = false) => {
    if (isMutedByPrimary && !force) return;

    if (!text) return;

    let textToSpeak = text;
    if (levelData && columns) {
      const replaced = replacePlaceholders(text, levelData, columns, appConfig);
      if (replaced) {
        textToSpeak = replaced;
      } else if (!force) {
        return;
      }
    }

    try {
      const { tts } = settings;
      const service = ttsFactory.getService(tts.provider);
      await service.speak(textToSpeak, {
        locale: locale,
        voice: tts.voice
      });
    } catch (error) {
      console.error('Speech error:', error);

      if (settings.tts.provider === 'azure') {
        showNotification(t('errors.ttsQuotaExceeded'), 'error');
        handleSettingChange('tts', 'provider', 'web-speech');
      } else {
        showNotification(t('errors.speechError'), 'error');
      }
    }
  }, [settings, locale, isMutedByPrimary, showNotification, t, appConfig, handleSettingChange]);

  return { speak };
};
